module.exports = __webpack_public_path__ + "static/media/Link-icon.29d5ec1f.svg";